import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'
import { fetchDefiLlamaApy } from './defillama'

/**
 * Kinetiq kHYPE — intrinsic staking APR.
 *
 * Sourced from DefiLlama's `kinetiq-khype` pool. hyperlend's
 * `nativeApy.kHYPE` (the previous source via `hypeFetcher`) has been
 * persistently null — empty history — so DefiLlama is the primary
 * source here. `apy` == `apyBase` for this pool (no incentive layer on
 * the LST itself).
 */
const KHYPE_POOL_ID = '9f25a954-db87-4bb2-a8b2-4be0b843a44c'

/** Shared key — matches the kHYPE registry entry's `yieldKey`. */
const KHYPE_KEY = 'Kinetiq Staked HYPE::kHYPE'

export const kinetiqKHypeFetcher: YieldFetcher = {
  label: 'KHYPE',
  fetch: async () => {
    // DefiLlama reports a compounded APY → convert to APR (pipeline convention).
    const apy = await fetchDefiLlamaApy(KHYPE_POOL_ID)
    return { [KHYPE_KEY]: apyToAprPercent(apy) }
  },
}
